import Fetch from "utils/fetch";

export const getDoorsByBusinessUnity = (idBusinessUnit) => Fetch.get(`/business-units/${idBusinessUnit}/doors`).then(({ data }) => data);
